._installedAppIndicator_1eor1_1 {
  display: flex; }
